module.exports = __webpack_public_path__ + "img/cover.512fbe5d.jpg";